import { ReactNode, MouseEvent, memo, useState, useEffect } from 'react';
import { Span } from '../../../../../../component/modal/ModalStyle';
import Modal from '../../../../../../component/modal/Modal.component'
import Button from '../../../../../../component/buttton/Button.component';
import GridComponent from "../../../../../../component/grid/GridComponent.component";
import { FormInput } from '../../../../../../component/input/InputStyle';
import { Grid } from '@material-ui/core';
import FormLabel from '../../../../../../component/input/FormLabel.component';
import { InterfaceRegisterModal } from '../../interface/InterfaceRegisterVehicle';


interface Props {
    children?: ReactNode;
    open: boolean;
    onClickSubmit(newNameDriver: string, newPlateVehicle: string, newVehiclePlate: string, newId: string): void;
    data: InterfaceRegisterModal;
    handleClick(event: MouseEvent<HTMLElement>): void
}



function ModalUpdate({ open, onClickSubmit, data, handleClick}: Props) {

    const [valueNameDriverModal, setValueNameDrivereModal] = useState('');
    const [valueDocumentModal, setValueDocumentModal] = useState('');
    const [valueVehiclePlate, setValueVehiclePlate] = useState('');
    const [idModal, setIdModal] = useState('');
    
    const handleChange = (event: any) => {
        const {value, name} = event.target
        if (name === 'driverName') {
            setValueNameDrivereModal(value);
        } 
        else if (name === 'document') {
            setValueDocumentModal(value);
        }
    }

    useEffect(() => {
        setValueNameDrivereModal(data.nome)
        setValueDocumentModal(data.documento)
        setValueVehiclePlate(data.placa)
        setIdModal(data.id)
        console.log('aqui')
    }, [open]);

        return (  
            <Modal size={'xl'} open={open} handleClick={() => {}} >
                <Span style={{textAlign:"center"}}>PLACA DO VEÍCULO {data.placa}</Span>
                <GridComponent margin="10px auto 10px auto" spacing={2}>
                <FormLabel title="Nome Motorista" sm={12} md={6} lg={6}>
                    <FormInput type="text" value={valueNameDriverModal === null ? '' : valueNameDriverModal} name="driverName" onChange={handleChange}/>
                </FormLabel>
                <FormLabel title="CNH" sm={12} md={6} lg={6}>
                    <FormInput type="text" value={valueDocumentModal === null ? '' : valueDocumentModal} name="document" onChange={handleChange}/>
                </FormLabel>
                    <Grid item margin="0 auto" xs={6}>
                        <Button title='Vincular' size='small' onClick={()=> onClickSubmit(valueNameDriverModal,valueDocumentModal, valueVehiclePlate, idModal)} fullWidth />
                    </Grid>
                    <Grid item margin="0 auto" xs={6}>
                        <Button title='Fechar' size='small' onClick={handleClick} fullWidth />
                    </Grid>
                </GridComponent>
            </Modal>
        );      
}

export default memo(ModalUpdate);